<template>
  <div>
    <div class="container text-center mb-5">
        <h1 class="bold300 text-uppercase" style=" font-weight:500;">Información Programática</h1>
    </div>

    <select2Filtros id="selectFiltro1" placeholder1="Seleccione año" placeholder2="Seleccione el trimestre" :data="data" @seleccionado="responseSelectComponent = $event" @titulo="textoTitulo = $event" />
    <tabla-simple id="tabla1Filtros" class="mt-5" :titulo="textoTitulo" :datos="responseSelectComponent" />

  </div>
</template>
<script>
import mapFun from '@/common/map-fn-types.js';
import ArmonizacionContableSH from "@/services/ArmonizacionContable/secretariaHacienda/ArmonizacionCSHacienda.service.js";
const _serviciosArmonizacionContableSH = new ArmonizacionContableSH();
// import('@/assets/css/tablaTypeFiles.css');
import tablaSimple from '@/components/tablaSimple.vue';
import select2Filtros from '@/components/selectCompuesto.vue'

export default {
  name: "informacionPresupuestal",
  data() {
    return{
      data: [],
      textoTitulo: '',
      responseSelectComponent: '',


    }
  },
  components: { tablaSimple, select2Filtros },
  async created() {
        await this.getInfoProgramatica();
    },
    methods: {
      async getInfoProgramatica() {
          try {
              const response = await _serviciosArmonizacionContableSH.getInfoProgramatica(mapFun.InfoProgramatica);
              // console.log(response);

              this.data = response.data.reverse();
              this.data = this.data.map(function (e) {
                return {
                    id:       e.id,
                    text:     e.titulo,
                    seccion:  e.contenido
                };
              });

          } catch (error) {
              console.log('error', error.message);
          }
      },
    }
}
</script>
